import useTheme from "../hooks/useTheme";

// Leaf component that owns the `useTheme` subscription. Mount it alongside
// the app tree (not above it) so theme-preference changes only re-render
// this null-rendering component instead of the entire App, preventing the
// cascade that would re-mount data-fetching pages and refire their
// `useEffect(reload, [])` calls on every theme toggle.
const ThemeApplier: React.FC = () => {
  useTheme();
  return null;
};

export default ThemeApplier;
